import type { FC, ReactNode } from 'react'

import SectionHeading from '@/components/landing/section-heading'
import { STEPS } from '@/constants/landing'

const HowItWorksSection: FC = (): ReactNode => {
    return (
        <section id='how-it-works' aria-labelledby='how-title' className='py-20 sm:py-28'>
            <div className='mx-auto max-w-6xl px-5 sm:px-6 lg:px-8'>
                <SectionHeading
                    id='how-title'
                    align='center'
                    eyebrow="How it works"
                    title="Up and running in three steps."
                    description="From the first call to your first morning on Elenix."
                />

                <ol className='mt-14 grid gap-5 md:grid-cols-3'>
                    {STEPS.map((step, index) => (
                        <li key={step.title} className='reveal relative overflow-hidden rounded-3xl border border-border bg-white p-7 sm:p-8'>
                            <span aria-hidden='true' className='pointer-events-none absolute -right-2 -top-6 font-heading text-[7.5rem] font-extrabold leading-none text-brand-50'>
                                {index + 1}
                            </span>

                            <span className='relative grid size-12 place-items-center rounded-2xl bg-primary font-heading text-lg font-bold text-primary-foreground shadow-[0_10px_22px_-10px_rgb(53_102_219/0.9)]'>
                                <span className='sr-only'>Step </span>
                                {index + 1}
                            </span>

                            <h3 className='relative mt-6 font-heading text-xl font-bold tracking-tight text-foreground'>
                                {step.title}
                            </h3>

                            <p className='relative mt-2 text-base leading-relaxed text-muted-foreground'>
                                {step.description}
                            </p>
                        </li>
                    ))}
                </ol>
            </div>
        </section>
    )
}

export default HowItWorksSection
